import { useState, useEffect, useCallback } from "react";
import { X, ChevronLeft, ChevronRight, ArrowRight, CalendarDays, Linkedin, Facebook, Mail, Target, ClipboardCheck, Boxes, TrendingUp, Users } from "lucide-react";
import { toast } from "sonner";
import { useLanguage } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/Reveal";

const PER_PAGE = 24;
const IDEA_ICONS = [Target, ClipboardCheck, Boxes, TrendingUp, Users];
const GALLERY_ORDER = [
  1, 338, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
  339, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 340, 38, 39, 40, 41, 42, 43, 44, 45,
  46, 341, 47, 342, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 343, 63, 64, 65, 66,
  67, 344, 68, 69, 70, 71, 72, 73, 74, 75, 76, 345, 77, 78, 79, 80, 81, 346, 347, 82, 348, 83, 84, 85,
  86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 349, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108,
  109, 110, 111, 112, 113, 350, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 351, 126, 127, 128, 129, 130,
  131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 352, 141, 142, 143, 353, 144, 145, 146, 147, 148, 149, 150, 151, 152,
  153, 154, 155, 156, 157, 158, 159, 354, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175,
  176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199,
  200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223,
  224, 225, 226, 227, 228, 355, 229, 230, 231, 356, 236, 237, 238, 239, 240, 241, 357, 242, 243, 244, 245, 246, 247, 248,
  249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 264, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275,
  276, 277, 278, 279, 280, 281, 282, 283, 284, 358, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 359,
  298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 360, 313, 314, 315, 316, 317, 318, 319, 320,
  361, 321, 322, 323, 362, 324, 325, 326, 363, 327, 328, 364, 365, 329, 330, 366, 331, 367, 332, 333, 334, 368, 335, 369,
  336, 370, 337,
];
const photos = GALLERY_ORDER.map((n) => {
  const nn = String(n).padStart(3, "0");
  return { thumb: `/img/galerie/g-${nn}-thumb.webp`, full: `/img/galerie/g-${nn}.jpg` };
});
const COUNT = photos.length;

const FOTOSTENA_COUNT = 33;
const fotostenaPhotos = Array.from({ length: FOTOSTENA_COUNT }, (_, i) => {
  const nn = String(i + 1).padStart(2, "0");
  return { thumb: `/img/fotostena/fs-${nn}-thumb.webp`, full: `/img/fotostena/fs-${nn}.jpg` };
});

const COMPANIES = [
  "ACTI PACK CZ, a.s.",
  "AG FOODS Group a.s.",
  "AKINU CZ s.r.o.",
  "Albert Česká republika, s.r.o.",
  "Argus, spol. s r.o.",
  "Asahi Europe & International",
  "ASIANA, spol. s r.o.",
  "Asociace českého papírenského průmyslu",
  "ASSA ABLOY Opening Solutions CZ s.r.o.",
  "ATOZ Marketing Services spol. s r.o.",
  "Authentica, s.r.o.",
  "Avery Dennison Praha spol. s r.o.",
  "AVT Emea",
  "beECOTECH a.s.",
  "Bidfood Opava s.r.o.",
  "Bizerba Czech & Slovakia s.r.o.",
  "BOXMAKER s.r.o.",
  "Budějovický Budvar, národní podnik",
  "CATUS spol. s r.o.",
  "CENTROPEN, a.s.",
  "CHEMOSVIT FOLIE, s.r.o.",
  "Coca Cola HBC Česko a Slovensko",
  "Colognia press, a.s.",
  "Comperio s.r.o.",
  "Delta Plus Slovensko s.r.o.",
  "DGS plast s.r.o.",
  "DILESTA PRODUCTION, s.r.o.",
  "Dr. Max Pharma s.r.o.",
  "DS Smith",
  "DS Smith Packaging Czech Republic s.r.o.",
  "EKO-KOM, a.s.",
  "Ekonews For Future Media s.r.o.",
  "ENVI - PAK, a.s.",
  "Envipco Slovakia s.r.o.",
  "EUROCORP SERVICES s.r.o.",
  "EXPORT PACKAGING CONSULTANCY SERVICES (PVT).LTD",
  "Ferring as, Czech Republic",
  "Ferring-Léčiva, a.s.",
  "FINEPACK SE",
  "GRAFOBAL, akciová spoločnosť",
  "GRANITOL akciová společnost",
  "Greiner packaging slušovice, s.r.o.",
  "Hamburger Recycling CZ s.r.o.",
  "Herbai a.s.",
  "HONEWA s.r.o.",
  "Hopi Popi a.s.",
  "hubergroup CZ s.r.o.",
  "Huhtamaki Česká republika, a.s.",
  "Hyundai Motor Manufacturing Czech s.r.o.",
  "I.D.C. Holding, a.s.",
  "IFCO SYSTEMS CZECH s.r.o.",
  "JACOBS DOUWE EGBERTS CZ s.r.o.",
  "JUST CS spol. s r.o.",
  "Kavalierglass, a.s.",
  "Kment, s.r.o.",
  "Koenig & Bauer (CEE) Sp. z o.o. organizační složka",
  "Kofola Československo a.s.",
  "Koito Czech s.r.o.",
  "LAVON trade s.r.o.",
  "LEROS, s.r.o.",
  "Lidl Česká republika s.r.o.",
  "LIKOV s.r.o.",
  "LITEGRA - Střední škola a Mateřská škola o.p.s.",
  "LOGIK, s.r.o.",
  "LRQA Česká republika s.r.o.",
  "LUXUR Media SK s.r.o.",
  "MADETA a. s.",
  "Magna Exteriors (Nymburk) s.r.o.",
  "MALITAS s.r.o.",
  "Mandario Company s.r.o.",
  "MANUFAKTURA s.r.o.",
  "Maso Uzeniny Polička",
  "mateco Czechia s.r.o.",
  "Mattoni 1873",
  "Meopta s.r.o.",
  "MILPACK s.r.o.",
  "Ministerstvo životního prostředí",
  "Mondi Bupak s.r.o.",
  "NATUR-PACK, a.s.",
  "Nestlé Česko s.r.o.",
  "NEXT MANAGERS s.r.o.",
  "Národní lesnický institut",
  "Obaly Morava, a.s.",
  "OTK printing & packaging a.s.",
  "Pekárna Anežka s.r.o.",
  "Penny Market s.r.o.",
  "Pierre Baguette s.r.o.",
  "PILOUS spol. s r.o.",
  "Plaček Pet Products s.r.o.",
  "Podorlická kartonážní spol. s r.o.",
  "POPAI CEservice, s.r.o.",
  "Potravinářská komora ČR",
  "PROPERTY & ENVIRONMENT s.r.o. (ODPADY-PORTAL.SK)",
  "PROveletrhy",
  "RACIO, s.r.o.",
  "RICHTR & Co., spol. s r.o.",
  "RUDOLF JELÍNEK a.s.",
  "Rudolf Kučera",
  "SAPLER a.s.",
  "Schicht prodej a.s.",
  "SCHOTT Termofrost s.r.o.",
  "SEMIX PLUSO, spol. s r.o.",
  "SENF, spol. s r.o.",
  "SERVISBAL OBALY s.r.o.",
  "Severochema, družstvo pro chemickou výrobu, Liberec",
  "Slovenské združenie pre značkové výrobky",
  "Smurfit Kappa Obaly Sturovo, a.s",
  "Smurfit Westrock Czech s.r.o.",
  "Smurfit Westrock Olomouc s.r.o.",
  "Smurfit Westrock Svitavy s.r.o.",
  "Sonnentor s.r.o.",
  "Státní zdravotní ústav",
  "Svět průmyslu",
  "Teknia Uhersky Brod, a.s.",
  "Tekro, spol. s r.o.",
  "The Candy Plus Sweet Factory, s.r.o.",
  "THIMM Obaly, k.s.",
  "TISKÁRNA GRAFICO s.r.o.",
  "TOMATA s.r.o.",
  "traytec s.r.o.",
  "TYČINKY s. r. o.",
  "UNIPAP Packaging a.s.",
  "Univerzita Pardubice",
  "ViaPharma s.r.o.",
  "ViaPharma s.r.o. (Lékárna Dr. Max)",
  "Vilgain s.r.o.",
  "Wipak",
  "ZÁLESÍ a.s.",
  "Zámecká výrobna uzenin spol. s r.o.",
  "ČEROZFRUCHT s.r.o.",
  "Česká asociace odpadového hospodářství",
];

// Volitelná loga firem: klíč = přesný název firmy, hodnota = soubor v /public/img/firmy/.
// Jakmile budou loga nahraná, stačí sem doplnit dvojice a dlaždice je zobrazí automaticky.
const COMPANY_LOGOS = {};

export const Recap = () => {
  const { t } = useLanguage();
  const r = t.recap;
  const [index, setIndex] = useState(null);
  const [lbList, setLbList] = useState(photos);
  const openLb = useCallback((list, i) => { setLbList(list); setIndex(i); }, []);
  const [page, setPage] = useState(0);
  const pageCount = Math.ceil(COUNT / PER_PAGE);
  const pageStart = page * PER_PAGE;
  const pagePhotos = photos.slice(pageStart, pageStart + PER_PAGE);
  const gotoPage = (p) => {
    const np = Math.max(0, Math.min(pageCount - 1, p));
    setPage(np);
    if (typeof document !== "undefined") {
      document.getElementById("recap-gallery")?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const shareUrl = typeof window !== "undefined" ? window.location.href : "https://summit.obalroku.cz/ohlednuti";

  const onNotify = async (e) => {
    e.preventDefault();
    if (!email || sending) return;
    setSending(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/forms/next-year`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error("submit failed");
      toast.success(r.nextYearSuccess);
      setEmail("");
    } catch {
      toast.error(t.common.submitError);
    } finally {
      setSending(false);
    }
  };

  const close = useCallback(() => setIndex(null), []);
  const prev = useCallback(() => setIndex((i) => (i - 1 + lbList.length) % lbList.length), [lbList]);
  const next = useCallback(() => setIndex((i) => (i + 1) % lbList.length), [lbList]);

  useEffect(() => {
    if (index === null) return;
    const onKey = (e) => {
      if (e.key === "Escape") close();
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [index, close, prev, next]);

  return (
    <section id="recap" className="relative py-24 md:py-32" data-testid="recap-section">
      <div className="container-page">
        <Reveal>
          <div className="overline text-[#CEA26B]">{r.overline}</div>
          <h1 className="mt-4 font-display font-black tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            {r.title}
          </h1>
          <div className="mt-5 inline-flex items-center gap-2 text-base md:text-lg font-semibold text-[#CEA26B]" data-testid="recap-intro-date">
            <CalendarDays className="h-5 w-5" />
            {r.introDate}
          </div>
          <div className="mt-6 max-w-5xl space-y-4 text-base md:text-lg text-slate-300 leading-relaxed">
            {r.introParas.map((p, i) => (
              <p key={i} data-testid={`recap-intro-para-${i}`}>{p}</p>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.05}>
          <div className="mt-16" data-testid="recap-ideas">
            <h2 className="font-display font-black tracking-tight text-white text-2xl sm:text-3xl">
              {r.ideasTitle}
            </h2>
            <div className="mt-10 grid gap-5 md:grid-cols-2">
              {r.ideas.map((idea, i) => {
                const Icon = IDEA_ICONS[i % IDEA_ICONS.length];
                const num = String(i + 1).padStart(2, "0");
                return (
                  <div
                    key={i}
                    data-testid={`recap-idea-${i}`}
                    className={`group relative overflow-hidden border border-white/10 bg-white/[0.03] p-6 md:p-8 transition-all duration-300 hover:border-[#CEA26B]/60 hover:bg-white/[0.06] ${i === r.ideas.length - 1 && r.ideas.length % 2 === 1 ? "md:col-span-2" : ""}`}
                  >
                    <span className="pointer-events-none absolute -right-3 -top-8 select-none font-display font-black leading-none text-[7rem] md:text-[9rem] text-white/[0.04] transition-colors duration-300 group-hover:text-[#CEA26B]/[0.08]">
                      {num}
                    </span>
                    <span className="absolute left-0 top-0 h-full w-1 bg-[#CEA26B]/0 transition-colors duration-300 group-hover:bg-[#CEA26B]" />
                    <div className="relative flex items-start gap-5">
                      <div className="flex shrink-0 flex-col items-center gap-2">
                        <span className="flex h-12 w-12 items-center justify-center bg-[#CEA26B] text-[#01154F]">
                          <Icon className="h-6 w-6" />
                        </span>
                        <span className="font-display text-xl font-black text-[#CEA26B]">{num}</span>
                      </div>
                      <div className="space-y-3 pt-0.5">
                        <h3 className="font-display font-bold text-white text-lg md:text-xl leading-snug">
                          {idea.title}
                        </h3>
                        {idea.paras.map((p, j) => (
                          <p key={j} className="text-base md:text-lg text-slate-300 leading-relaxed">{p}</p>
                        ))}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.05}>
          <div className="mt-16 max-w-5xl">
            <h2 className="font-display font-black tracking-tight text-white text-2xl sm:text-3xl" data-testid="recap-bridge-title">
              {r.bridgeTitle}
            </h2>
            <div className="mt-6 space-y-4 text-base md:text-lg text-slate-300 leading-relaxed">
              {r.bridgeParas.map((p, i) => (
                <p key={i} data-testid={`recap-bridge-para-${i}`}>{p}</p>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-3" data-testid="recap-share">
              <span className="text-sm font-semibold text-slate-400">{r.shareLabel}:</span>
              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="recap-share-linkedin"
                className="inline-flex items-center gap-2 border border-white/15 px-4 py-2 text-sm font-semibold text-white hover:border-[#CEA26B] hover:text-[#CEA26B] transition-colors"
              >
                <Linkedin className="h-4 w-4" />
                LinkedIn
              </a>
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="recap-share-facebook"
                className="inline-flex items-center gap-2 border border-white/15 px-4 py-2 text-sm font-semibold text-white hover:border-[#CEA26B] hover:text-[#CEA26B] transition-colors"
              >
                <Facebook className="h-4 w-4" />
                Facebook
              </a>
              <a
                href={`mailto:?subject=${encodeURIComponent(r.shareEmailSubject)}&body=${encodeURIComponent(`${r.title} — ${shareUrl}`)}`}
                data-testid="recap-share-email"
                className="inline-flex items-center gap-2 border border-white/15 px-4 py-2 text-sm font-semibold text-white hover:border-[#CEA26B] hover:text-[#CEA26B] transition-colors"
              >
                <Mail className="h-4 w-4" />
                E-mail
              </a>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.05}>
          <div
            className="mt-6 inline-flex items-center gap-2 border border-[#CEA26B]/40 bg-[#CEA26B]/10 px-4 py-2 text-sm text-[#CEA26B]"
            data-testid="recap-first-photos-note"
          >
            <span className="h-1.5 w-1.5 rounded-full bg-[#CEA26B]" />
            {r.firstPhotosNote}
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-10 overflow-hidden border border-white/10 bg-black" data-testid="recap-video">
            <video
              controls
              playsInline
              preload="metadata"
              className="aspect-video w-full"
            >
              <source src="/video/summit-2026.mp4" type="video/mp4" />
            </video>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div id="recap-gallery" className="scroll-mt-28 columns-1 sm:columns-2 lg:columns-3 gap-4 [column-fill:_balance] mt-12">
            {pagePhotos.map((p, i) => {
              const gi = pageStart + i;
              return (
              <button
                key={gi}
                onClick={() => openLb(photos, gi)}
                data-testid={`recap-photo-${gi}`}
                className="group mb-4 block w-full overflow-hidden border border-white/10 bg-white/[0.02] focus:outline-none focus:ring-2 focus:ring-[#CEA26B]"
              >
                <img
                  src={p.thumb}
                  alt={`${r.title} — ${gi + 1}`}
                  loading="lazy"
                  className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                />
              </button>
              );
            })}
          </div>

          <div className="mt-10 flex flex-col items-center gap-4" data-testid="recap-pagination">
            <div className="text-sm text-slate-400">
              {pageStart + 1}–{Math.min(pageStart + PER_PAGE, COUNT)} / {COUNT}
            </div>
            <div className="flex flex-wrap items-center justify-center gap-1.5">
              <button
                onClick={() => gotoPage(page - 1)}
                disabled={page === 0}
                data-testid="recap-page-prev"
                className="inline-flex h-9 items-center gap-1 border border-white/15 px-3 text-sm text-white hover:border-[#CEA26B] hover:text-[#CEA26B] transition-colors disabled:opacity-30 disabled:pointer-events-none"
              >
                <ChevronLeft className="h-4 w-4" />
              </button>
              {Array.from({ length: pageCount }, (_, p) => p)
                .filter((p) => p === 0 || p === pageCount - 1 || Math.abs(p - page) <= 1)
                .reduce((acc, p) => {
                  if (acc.length && p - acc[acc.length - 1] > 1) acc.push("…");
                  acc.push(p);
                  return acc;
                }, [])
                .map((p, idx) =>
                  p === "…" ? (
                    <span key={`e${idx}`} className="px-2 text-slate-500">…</span>
                  ) : (
                    <button
                      key={p}
                      onClick={() => gotoPage(p)}
                      data-testid={`recap-page-${p}`}
                      className={`h-9 min-w-9 px-3 border text-sm transition-colors ${
                        p === page
                          ? "border-[#CEA26B] bg-[#CEA26B] text-[#01154F] font-bold"
                          : "border-white/15 text-white hover:border-[#CEA26B] hover:text-[#CEA26B]"
                      }`}
                    >
                      {p + 1}
                    </button>
                  )
                )}
              <button
                onClick={() => gotoPage(page + 1)}
                disabled={page === pageCount - 1}
                data-testid="recap-page-next"
                className="inline-flex h-9 items-center gap-1 border border-white/15 px-3 text-sm text-white hover:border-[#CEA26B] hover:text-[#CEA26B] transition-colors disabled:opacity-30 disabled:pointer-events-none"
              >
                <ChevronRight className="h-4 w-4" />
              </button>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="container-page mt-24 md:mt-32" data-testid="recap-fotostena">
        <Reveal>
          <h2 className="font-display font-black tracking-tight text-white text-2xl sm:text-3xl lg:text-4xl">
            {r.fotostenaTitle}
          </h2>
          <p className="mt-4 max-w-2xl text-base md:text-lg text-slate-300 leading-relaxed">
            {r.fotostenaLead}
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 gap-4">
            {fotostenaPhotos.map((p, i) => (
              <button
                key={i}
                onClick={() => openLb(fotostenaPhotos, i)}
                data-testid={`recap-fotostena-${i}`}
                className="group block w-full overflow-hidden border border-white/10 bg-[#01154F] focus:outline-none focus:ring-2 focus:ring-[#CEA26B]"
              >
                <img
                  src={p.thumb}
                  alt={`${r.fotostenaTitle} — ${i + 1}`}
                  loading="lazy"
                  className="aspect-[4/5] w-full object-contain transition-transform duration-500 group-hover:scale-[1.03]"
                />
              </button>
            ))}
          </div>
        </Reveal>
      </div>

      <div className="container-page mt-24 md:mt-32" data-testid="recap-companies">
        <Reveal>
          <div className="flex items-baseline gap-4" data-testid="recap-companies-stat">
            <span className="font-display font-black tracking-tighter text-[#CEA26B] text-5xl sm:text-6xl lg:text-7xl leading-none">
              {r.statNumber}
            </span>
            <span className="text-base md:text-lg text-slate-300 font-medium">
              {r.statLabel}
            </span>
          </div>
          <h2 className="mt-8 font-display font-black tracking-tight text-white text-2xl sm:text-3xl lg:text-4xl">
            {r.companiesTitle}
          </h2>
          <p className="mt-4 max-w-2xl text-base md:text-lg text-slate-300 leading-relaxed">
            {r.companiesLead}
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <ul className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
            {COMPANIES.map((c, i) => (
              <li
                key={i}
                data-testid={`recap-company-${i}`}
                className="group flex min-h-[88px] items-center justify-center border border-white/10 bg-white/[0.03] p-4 text-center transition-colors hover:border-[#CEA26B]/50 hover:bg-white/[0.06]"
              >
                {COMPANY_LOGOS[c] ? (
                  <img
                    src={`/img/firmy/${COMPANY_LOGOS[c]}`}
                    alt={c}
                    loading="lazy"
                    className="max-h-14 max-w-full object-contain"
                  />
                ) : (
                  <span className="text-sm leading-snug text-slate-200">{c}</span>
                )}
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.1}>
          <div
            className="mt-20 border border-white/10 bg-white/[0.03] p-8 md:p-12"
            data-testid="recap-next-year"
          >
            <h2 className="font-display font-black tracking-tight text-white text-2xl sm:text-3xl">
              {r.nextYearTitle}
            </h2>
            <div className="mt-4 flex flex-wrap items-center gap-x-6 gap-y-2" data-testid="recap-next-year-when">
              <span className="inline-flex items-center gap-2 text-base md:text-lg font-semibold text-[#CEA26B]">
                <CalendarDays className="h-5 w-5" />
                {r.nextYearWhen}
              </span>
            </div>
            <p className="mt-4 max-w-2xl text-base md:text-lg text-slate-300 leading-relaxed">
              {r.nextYearLead}
            </p>
            <form onSubmit={onNotify} className="mt-8 flex flex-col sm:flex-row gap-3 max-w-xl">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={r.nextYearPlaceholder}
                data-testid="recap-next-year-email"
                className="flex-1 bg-[#01154F] border border-white/15 px-4 py-3 text-white placeholder:text-slate-500 focus:outline-none focus:border-[#CEA26B] transition-colors"
              />
              <button
                type="submit"
                disabled={sending}
                data-testid="recap-next-year-submit"
                className="inline-flex items-center justify-center gap-2 bg-[#CEA26B] px-6 py-3 font-display font-bold text-[#01154F] hover:bg-[#d9b47f] transition-colors disabled:opacity-60"
              >
                {r.nextYearButton}
                <ArrowRight className="h-4 w-4" />
              </button>
            </form>
          </div>
        </Reveal>
      </div>

      {index !== null && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-[#01154F]/95 backdrop-blur-sm"
          data-testid="recap-lightbox"
          onClick={close}
        >
          <button
            onClick={close}
            data-testid="recap-lightbox-close"
            className="absolute top-5 right-5 p-2 text-white/80 hover:text-[#CEA26B] transition-colors"
            aria-label="Zavřít"
          >
            <X className="h-7 w-7" />
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); prev(); }}
            className="absolute left-3 sm:left-6 p-2 text-white/80 hover:text-[#CEA26B] transition-colors"
            aria-label="Předchozí"
          >
            <ChevronLeft className="h-9 w-9" />
          </button>
          <img
            src={lbList[index].full}
            alt={`${r.title} — ${index + 1}`}
            onClick={(e) => e.stopPropagation()}
            className="max-h-[85vh] max-w-[90vw] object-contain shadow-2xl"
            data-testid="recap-lightbox-image"
          />
          <button
            onClick={(e) => { e.stopPropagation(); next(); }}
            className="absolute right-3 sm:right-6 p-2 text-white/80 hover:text-[#CEA26B] transition-colors"
            aria-label="Další"
          >
            <ChevronRight className="h-9 w-9" />
          </button>
          <div className="absolute bottom-5 left-1/2 -translate-x-1/2 font-display text-sm tabular-nums text-[#CEA26B]">
            {index + 1} / {lbList.length}
          </div>
        </div>
      )}
    </section>
  );
};
